// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HeadlineMetric[data-v-05e165d9]{min-width:300px;position:relative}.verticalBorder[data-v-05e165d9]{border-right:1px solid}.horizontalBorder[data-v-05e165d9]{bottom:0;height:1px;left:0;margin:auto;position:absolute;right:0;width:92px}dd[data-v-05e165d9]{font-size:52px}dt[data-v-05e165d9]{margin-top:-10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
